Ext.define('SA.BrowserTabId', {
    singleton: true,

    ensureSet() {
        var id = this.get() ?? Math.random(); 

        SA.SessionStorage.set('tabId', id);
    },

    get() {
        return SA.SessionStorage.get('tabId');
    }
});